import { RunAction } from './Actions';
export function makeInitialState() {
  return {
    Public: {
      appName: null,
      appLogo: null,
    },
    Auth: {
      logged: null,
      profile: null,
      workspace: null,
    },
    Props: {
      itemsCountPerPage: localStorage.getItem("@footab/itemsCountPerPage") || 50,
      isSocketConnected: true,
    },
    Chats: [],
    Notifications: [],
  };
}
const reducer = (state, reducerAction) => {
  const { type, payload, action } = reducerAction;
  return RunAction({ type, state, payload, action });
};
export default reducer;
